import * as constants from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const HlaseniOSkode = {
	name: constants.NAME,
	apiProvider,
	router,
};
